<template>
  <div class="grid-responsive">
    <div class="grid">
      <div v-for="(item, i) in items" :key="item.id"
        :class="['grid-item', { 'grid-item-staff-avatar': showStaffAvatarItem }]"
        :style="gridItemStyle(item, i)"
        @click="handleClickItem(item, i)">
        <template v-if="showStaffAvatarItem">
          <div
            class="staff-avatar"
            :style="{ borderColor: $store.getters.printStaffColor(item) }">
            <img
              v-if="staffAvatarUrl(item)"
              :src="staffAvatarUrl(item)"
              :srcset="staffAvatarSrcset(item)"
              :alt="$store.getters.printStaffName(item.id)"
              class="staff-avatar-img">
            <span v-else class="staff-avatar-initials">{{ staffInitials(item) }}</span>
          </div>
          <div class="staff-avatar-info">
            <span class="staff-avatar-name">{{ $store.getters.printStaffName(item.id) }}</span>
            <span class="staff-avatar-ref">{{ item.ref }} sss</span>
          </div>
        </template>
        <template v-else>
          {{ type == 'staff' ? $store.getters.printStaffName(item.id) : item.name }}<br>
          <template v-if="type == 'staff'">{{ item.ref }}</template>
        </template>
      </div>
      <div class="text-result" v-if="!items.length" v-translate>No results found!</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GridView',
  props: {
    items: { type: Array, default: () => ([]) },
    highlight: { type: Boolean, default: false },
    showStaffAvatar: { type: Boolean, default: false },
    type: { type: String, default: '' },
  },
  data() {
    return {
      currentIndex: null,
    };
  },
  methods: {
    gridItemStyle(item, index) {
      const isHighlighted = this.currentIndex === index && this.highlight;
      let backgroundColor = this.showStaffAvatarItem ? '#ffffff' : this.$store.getters.printStaffColor(item);
      if (isHighlighted) {
        backgroundColor = '#b4ded5';
      }
      return { backgroundColor };
    },
    normalizeAvatarPath(path) {
      if (!path) return '';
      const normalized = String(path).replace(/\\/g, '').replace(/^\/+/, '');
      if (!normalized) return '';
      if (/^https?:\/\//.test(normalized)) return normalized;
      if (normalized.indexOf('api/') === 0) return `/${normalized}`;
      return `/api/${normalized}`;
    },
    staffAvatarUrl(item) {
      return this.normalizeAvatarPath(item.avatarUrl || item.picture);
    },
    staffAvatarSrcset(item) {
      const avatarUrl = this.staffAvatarUrl(item);
      const largeAvatarUrl = this.normalizeAvatarPath(item.avatarLargeUrl);
      return largeAvatarUrl && largeAvatarUrl !== avatarUrl
        ? `${avatarUrl} 1x, ${largeAvatarUrl} 2x`
        : null;
    },
    staffInitials(item) {
      const names = [item.firstName, item.lastName].filter(Boolean);
      const initials = names.map(name => String(name).charAt(0)).join('');
      return initials ? initials.substring(0, 2).toUpperCase() : '#';
    },
    handleClickItem(item, index) {
      this.currentIndex = index;
      this.$emit('pickItem', item);
    },
  },
  computed: {
    showStaffAvatarItem() {
      return this.type === 'staff' && this.showStaffAvatar;
    },
  },
};
</script>
